(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('SidebarViewsController', SidebarViewsController);

  SidebarViewsController.$inject = ['$state', '$scope', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

  function SidebarViewsController($state, $scope, Auth, Principal, ProfileService, LoginService) {
    var vm = $scope;
    vm.showSuggestionsVar = 'falsee';

    vm.triggerObj = {};
    vm.triggerObj.trigger = false;
    $scope.name = 'SidebarController';
    vm.isNavbarCollapsed = true;
    vm.isAuthenticated = Principal.isAuthenticated;
    vm.currentState = $state.current.parent;

    ProfileService.getProfileInfo().then(function (response) {
      vm.inProduction = response && response.inProduction;
      vm.swaggerEnabled = response && response.swaggerEnabled;
    });
    Principal.countAuthorities().then(function (c) {
      if (c === 1) {
        Principal.hasAnyAuthority(['MERCHANT_ROSSETTI', 'MERCHANT_SUPERMEDIA']).then(function (result) {
          vm.isSupermedia = result;
        });
      }
    });
    vm.login = login;
    vm.logout = logout;
    vm.toggleNavbar = toggleNavbar;
    vm.collapseNavbar = collapseNavbar;
    vm.showUlSuggestions = showUlSuggestions;
    vm.$state = $state;

    function showUlSuggestions() {
      if (vm.triggerObj.trigger == true) {
        vm.triggerObj.trigger = false;
      }
      else {
        vm.triggerObj.trigger = true;
      }
    }

    function login() {
      collapseNavbar();
      LoginService.open();
    }

    function logout() {
      collapseNavbar();
      Auth.logout();
      $state.go('home');
    }

    function toggleNavbar() {
      vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
    }

    function collapseNavbar() {
      vm.isNavbarCollapsed = true;
    }
  }
})();
